function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 45,
  fill: "#5DC976",
  fillOpacity: 0.2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M62.9998 39.6208L45.0001 51L27.0002 39.6208V22.0347C26.9878 21.4755 27.4418 21.0124 28.0141 21.0002C28.0291 21 28.0441 21 28.0591 21.0002H61.9409C62.5133 20.9881 62.9874 21.4316 62.9998 21.9908C63.0001 22.0055 63.0001 22.0201 62.9998 22.0348V39.6208Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.2566 40.1003L21 35.8336L27.2566 29.4336V40.1003Z",
  fill: "#F6B445"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M68.9676 35.8336L62.7109 40.1003V29.4336L68.9676 35.8336Z",
  fill: "#F6B445"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M62.6516 39.5092L69.0001 35.4V64.8259C68.9981 65.9406 68.5532 67.0094 67.7621 67.8L60.5354 60.6223L48.8964 49.062L48.6001 48.6101L62.6516 39.5092Z",
  fill: "#FED049"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M60.6665 60.6006L67.7999 67.7716C67.0142 68.5565 65.952 68.998 64.8442 69H25.1557C24.0479 68.998 22.9857 68.5565 22.2 67.7716L29.3334 60.6006L40.8221 49.0515L41.1146 48.6L44.9999 51.1513L48.8852 48.6L49.1777 49.0515L60.6665 60.6006Z",
  fill: "#F6B445"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M41.4 48.6102L41.1037 49.0621L29.4647 60.6222L22.238 67.8C21.4469 67.0094 21.002 65.9406 21 64.8259V35.4L41.4 48.6102Z",
  fill: "#FED049"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M55.8889 27.8467H32.8787C32.3011 27.8467 31.8328 27.4025 31.8328 26.8545C31.8328 26.3065 32.3011 25.8622 32.8787 25.8622H55.8889C56.4665 25.8622 56.9348 26.3065 56.9348 26.8545C56.9348 27.4025 56.4665 27.8467 55.8889 27.8467Z",
  fill: "#D0D7DF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M55.8889 32.8079H32.8787C32.3011 32.8079 31.8328 32.3636 31.8328 31.8156C31.8328 31.2676 32.3011 30.8234 32.8787 30.8234H55.8889C56.4665 30.8234 56.9348 31.2676 56.9348 31.8156C56.9348 32.3636 56.4665 32.8079 55.8889 32.8079Z",
  fill: "#D0D7DF"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M55.889 37.7691H53.7972C53.2195 37.7691 52.7512 37.3248 52.7512 36.7768C52.7512 36.2288 53.2195 35.7845 53.7972 35.7845H55.889C56.4666 35.7845 56.9349 36.2288 56.9349 36.7768C56.9349 37.3249 56.4666 37.7691 55.889 37.7691Z",
  fill: "#D0D7DF"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M49.6133 37.7691H47.5215C46.9439 37.7691 46.4756 37.3248 46.4756 36.7768C46.4756 36.2288 46.9439 35.7845 47.5215 35.7845H49.6133C50.191 35.7845 50.6593 36.2288 50.6593 36.7768C50.6593 37.3249 50.191 37.7691 49.6133 37.7691Z",
  fill: "#D0D7DF"
});

function SvgEmailed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailed);
export default __webpack_public_path__ + "static/media/emailed.e5056e8d.svg";
export { ForwardRef as ReactComponent };